import { ScanApiConstant } from '../actionTypes/scan.constant';
import axios from 'axios';
import { AuthHeader } from "../helper/auth.token";
import { setDeviceIdle, setDeviceBusy } from './device_status.action';
import { message } from 'antd'

export const initPreviewForScan = (slot, defaultConfig) => ({
    type: ScanApiConstant.INIT_PREVIEW,
    slot: slot, 
    defaultConfig: defaultConfig
})

export const fetchingPreview = (slot) => ({
    type: ScanApiConstant.TAKING_PREVIEW,
    slot: slot
})

export const receivedPreviewStatus = (type, response, slot) => ({
    type: type,
    response: response,
    slot: slot
})

export const setDoTilingOnly = (slot) => ({
    type: ScanApiConstant.SET_DO_TILING_ONLY, 
    slot: slot
})

export const unsetDoTilingOnly = (slot) => ({
    type: ScanApiConstant.UNSET_DO_TILING_ONLY, 
    slot: slot
})

export const setSpecimenType = (slot, specimenType) => ({
    type: ScanApiConstant.SPECIMEN_TYPE_CHANGE, 
    specimenType: specimenType, 
    slot: slot
})

export const setObjectiveType = (slot, objectiveType) => ({
    type: ScanApiConstant.OBJECTIVE_TYPE_CHANGE, 
    objectiveType: objectiveType, 
    slot: slot
})

export const setScanOutputFormat = (slot, scanOutputFormat) => ({
    type: ScanApiConstant.SCAN_OUTPUT_FORMAT_CHANGE, 
    scanOutputFormat: scanOutputFormat, 
    slot: slot
})

export const selectionDone = (slot) => ({
    type: ScanApiConstant.REGION_SELECTION_DONE, 
    slot:slot
})

export const selectionCancelled = (slot) => ({
    type: ScanApiConstant.SELECTION_CANCELLED, 
    slot:slot
})

export const setPreviewStatusToConfirmed = (slot, region, actualRegion) => ({
    type: ScanApiConstant.SELECTION_CONFIRMED, 
    slot: slot, 
    region: region, 
    actualRegion: actualRegion
})

export const setScanSpeed = (slot, speed) => ({
    type: ScanApiConstant.SPEED_CHANGE, 
    slot: slot,
    speed: speed
})

export const setScanSpeedForAllSlots = (speed) => ({
    type: ScanApiConstant.SPEED_CHANGE_FOR_ALL_SLOTS, 
    speed: speed
})

export const setScanName = (slot, name) => ({
    type: ScanApiConstant.NAME_CHANGE, 
    slot: slot,
    name: name
})

export const takePreview = (id, slot) => (dispatch) => {
    dispatch(setDeviceBusy(id));
    dispatch(fetchingPreview(slot));
    let url = `/devices/` + id + "/take_preview?slot_id=" + slot;
    axios.get(url, { headers: { Authorization: AuthHeader() } })
        .then(response => {
            if (response.status === 200) {
                dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, JSON.parse(response.data), slot))
                dispatch(setDeviceIdle(id));
            }
            else {
                dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, response, slot))
                dispatch(setDeviceIdle(id));
            }
        })
        .catch(err => {
            dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, err, slot))
            dispatch(setDeviceIdle(id));
            console.log(err)
        })
}

export const takeAllPreviews = (id, loaderCapacity, setShowSummary) => (dispatch) => {
    dispatch(setDeviceBusy(id));
    for (var i = 0; i < loaderCapacity; i++) {
        dispatch(fetchingPreview(i));
    }
    let url = `/devices/` + id + "/take_all_previews/";
    axios.get(url, { headers: { Authorization: AuthHeader() } })
        .then(response => {
            if (response.status === 200) {
                let previewResponses = JSON.parse(response.data);
                for (var i = 0; i < loaderCapacity; i++) {
                    let previewResponse = previewResponses[i];
                    let reg = {
                        data: { index: 0 },
                        height: 100,
                        isChanging: false,
                        new: false,
                        width: 100,
                        x: 0,
                        y: 0,
                    }
                    let x1 = parseInt((reg.x * previewResponse.previewWidth) / 100.0);
                    let x2 = parseInt(((reg.x + reg.width) * previewResponse.previewWidth) / 100.0);
                    let y1 = parseInt((reg.y * previewResponse.previewHeight) / 100.0);
                    let y2 = parseInt(((reg.y + reg.height) * previewResponse.previewHeight) / 100.0);
                    let actualReg = [x1, y1, x2, y2];
                    dispatch(receivedPreviewStatus(ScanApiConstant.TAKEN_PREVIEW, previewResponse, i));
                    dispatch(setPreviewStatusToConfirmed(i, reg, actualReg));
                }
                dispatch(setDeviceIdle(id));
                setShowSummary(true);
            }
            else {
                for (var i = 0; i < loaderCapacity; i++) {
                    dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, response, i));
                }
                dispatch(setDeviceIdle(id));
            }
        })
        .catch(err => {
            for (var i = 0; i < loaderCapacity; i++) {
                dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW, err, i));
            }
            dispatch(setDeviceIdle(id));
            console.log(err)
        })
}

export const selectionConfirmed = (id, slot, regionInCanvas, actualRegion, image, name, startScanCallback, loaderCapacity, specimenType) => (dispatch) => {
    dispatch(setDeviceBusy(id));
    let url = '/devices/' + id + "/send_threshold_image/?slot_id=" + slot;  
    axios({
        method:"post",
        url : url, 
        data: {
            imgBase64: image, 
            specimenType: specimenType
        }
    })
    .then(response => {
        if (response.status === 200) {
            dispatch(setPreviewStatusToConfirmed(slot, regionInCanvas, actualRegion));
            dispatch(setDeviceIdle(id));
            if (loaderCapacity === 1) {
                startScanCallback();
            }
        }
        else {
            dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, slot))
            dispatch(setDeviceIdle(id));
        }
    })
    .catch(err => {
        dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, slot))
        dispatch(setDeviceIdle(id));
    })
}

export const startScanning = (id, previewData) => (dispatch) => {
    dispatch(setDeviceBusy(id, "Initialising"));
    let url = '/devices/' + id + '/start_scan/';
    axios({
        method:"post",
        url : url, 
        data: {
            previewData: previewData
        }
    })
    .then(response => {
        if (response.status === 200) {
            message.success("Started Scans");
            dispatch(setDeviceIdle(id));
        }
        else {
            message.error("Could not start scans. Please contact administrator.")
            dispatch(setDeviceIdle(id));
        }
    })
    .catch(err => {
        message.error("Could not start scans. Please contact administrator.")
        dispatch(setDeviceIdle(id));
    })
}

export const cancelScanning = (id) => (dispatch) => {
    dispatch(setDeviceBusy(id, "Cancelling"));
    let url = '/devices/' + id + '/cancel/';
    axios
    .get(url)
    .then(response => {
        if (response.status === 200) {
            message.success("Cancelled Scanning");
            dispatch(setDeviceIdle(id));
        }
        else {
            message.error("Could not cancel scanning. Please contact administrator.")
            dispatch(setDeviceIdle(id));
        }
    })
    .catch(err => {
        message.error("Could not cancel scanning. Please contact administrator.")
        dispatch(setDeviceIdle(id));
    })
}